import React from 'react';
import { ReactComponent as WaterLogo } from 'assets/icons/ui-icon-utility-24-water-circle.svg';
import { ReactComponent as ElectricityLogo } from 'assets/icons/ui-icon-utility-24-electricity-circle.svg';
import { ReactComponent as GasLogo } from 'assets/icons/ui-icon-utility-24-gas-circle.svg';
import { ReactComponent as GovLogo } from 'assets/icons/ui-icon-utility-24-gov-circle.svg';
import { ReactComponent as PhoneLogo } from 'assets/icons/ui-icon-utility-24-comms-circle.svg';
import { ReactComponent as OtherLogo } from 'assets/icons/ui-icon-utility-24-other-circle.svg';

const UtilityIcons: React.FC<any> = (props: any) => {
  switch (props.type.toLowerCase()) {
    case 'water':
      return <WaterLogo />;
    case 'electric':
      return <ElectricityLogo />;
    case 'gas':
      return <GasLogo />;
    case 'local government':
      return <GovLogo />;
    case 'telco':
      return <PhoneLogo />;
    case 'other':
      return <OtherLogo />;
    default:
      return null;
  }
};
export default UtilityIcons;
